import { createRouter, createWebHistory } from 'vue-router';
import { createApp } from 'vue';
import config from './config.json';
import App from './App.vue';
import Toast from 'vue-toastification';
import Vue3Autocounter from 'vue3-autocounter';
import VueHighlightJS from 'vue3-highlightjs'
import HomeComponent from '@/components/HomeComponent.vue';
import QuizComponent from '@/components/QuizComponent.vue';
import QuizResultComponent from '@/components/QuizResultComponent.vue';
import 'vue-toastification/dist/index.css';
import 'highlight.js/styles/atom-one-dark.css';

const APP_DEFAULT_TITLE = 'Quiz – digital verein(t)';

const routes = [
    {
        path : '/',
        name: 'home',
        component : HomeComponent,
    },
    {
        path: '/quiz/:id/:questionIndex',
        name: 'quiz',
        component: QuizComponent,
    },
    {
        path: '/quiz/:id/result/:score?',
        name: 'result',
        component: QuizResultComponent,
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/',
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return {
            top: 0,
            left: 0,
        };
    },
});

// Change document title after route changed
router.afterEach((to) => {
    switch (to.name) {
        case 'quiz':
            document.title = `${APP_DEFAULT_TITLE} | ${to.params.id} | Frage ${(parseInt((to.params.questionIndex).toString()) + 1)}`;
            break;
        case 'result':
            document.title = `Ergebnis für Quiz "${to.params.id}" = ${to.params.score}%`;
            break;
        default:
            document.title = APP_DEFAULT_TITLE;
    }
});

createApp(App)
    .use(router)
    .use(Vue3Autocounter)
    .use(VueHighlightJS)
    .use(Toast, {
        containerClassName: 'dive-toast',
        timeout: config.toastTimeoutInMs,
        position: config.toastDefaultPosition,
    })
    .mount('#app');
